import { type ReactNode } from 'react';
import styles from './AgentCard.module.scss';
import Image from '@/src/shared/components/Image';

interface Props {
  name: string;
  title: string;
  comment: ReactNode;
  avatarUrl: string;
  role: ReactNode;
}

export function AgentCard({ name, title, comment, avatarUrl, role }: Props) {
  return (
    <div className={styles.card}>
      <Image
        src="/images/testimonials/5.svg"
        alt="5stars"
        width={80}
        height={16}
      />
      <h6 className={styles.title}>{title}</h6>
      <p className={styles.comment}>{comment}</p>
      <div className={styles.agentInfo}>
        <Image
          src={`/images/testimonials/slider/${avatarUrl}`}
          alt={name}
          width={60}
          height={60}
          className={styles.agentAvatar}
        />
        <div>
          <p className={styles.agentName}>{name}</p>
          <p className={styles.agentRole}>{role}</p>
        </div>
      </div>
    </div>
  );
}
